export function catalogIdToStoreName(catalogId) {
  switch (catalogId) {
    case 'ajioStreet':
      return 'street';
    case 'beautybridgetoluxury':
      return 'luxe';
    case 'luxuryProductCatalog':
      return 'luxe';
    default:
      return 'ajio';
  }
}
